import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('carrier_brand', '/carrier_brands')
const reducer = generator.generate()

export default reducer
